import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApicallsService } from '../services/apicalls.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { AlertService } from '../services/alert.service';
import { first } from 'rxjs/operators';

import swal from 'sweetalert2';
import toastr from 'toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  year: any;
  formLogin: FormGroup;
  pasError = false; 
  levelPass = 0;
  formForgot: FormGroup;
  formNewPassword: FormGroup;
  loading = false;
  submitted = false;
  showForgot = false;
  newUser = false;
  idUser: any;
  returnUrl: string;
  showPassword = false;

  constructor(private formBuilder: FormBuilder,
              private route: ActivatedRoute,
              private api: ApicallsService,
              private router: Router,
              private spinner: NgxSpinnerService,
              private authenticationService: AuthenticationService,
              private alertService: AlertService) {
              
              
              if (this.authenticationService.currentUserValue) {
                  this.router.navigate(['/dashboard']);
              }
  }

  ngOnInit() {
    this.year = new Date().getFullYear();
    this.formLogin = this.formBuilder.group({
        username: ['', [ Validators.required, Validators.email]],
        password: ['', Validators.required]
    });

    this.formForgot = this.formBuilder.group({
      username: ['', [ Validators.required, Validators.email]],
    });
    this.formNewPassword = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirm: ['', [Validators.required, Validators.minLength(6)]]
    });

    if (this.route.snapshot.queryParams['e'] && this.route.snapshot.queryParams['p']) {
      this.formLogin.patchValue({username: window.atob(this.route.snapshot.queryParams['e'])});
      this.formLogin.patchValue({password: window.atob(this.route.snapshot.queryParams['p'])});
    }
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
  }

  forgot() {
    this.showForgot = true;
  }

  visiblePassword(value) {
      this.showPassword = value;
  }

  login(formValue: any) {
    this.spinner.show();
    this.authenticationService.login( formValue.username , formValue.password )
      .pipe(first())
      .subscribe( data => {
          this.spinner.hide();
          if (data.user.change_password === 1) {
            swal.fire('Primera visita',
            'Por motivos de seguridad, en tu primera visita al panel, debes actualizar la contraseña', 'warning');
            this.newUser = true;
            this.idUser = data.user.id;
          } else {
            this.router.navigate(['/dashboard']);
          }
        },
        error => {
          this.spinner.hide();
          swal.fire('Login', 'No tienes permiso para entrar a la aplicación', 'error');
        }
      );
  }

  sendForgot(formValue: any) {
    this.spinner.show();
    this.api.forgotPassword(formValue).subscribe( (res: any) => {
      this.spinner.hide();
      if ( res.error) {
        swal.fire('Cambiar Contraseña', res.error, 'error');
      } else {
          toastr.success(null, 'Revisa tu correo para poder cambiar tu contraseña', {positionClass: 'toast-top-center'});
          this.formForgot.controls.username.reset();
          this.showForgot = false;
      }
    }, error => {
      this.spinner.hide();
      swal.fire('Cambiar Contraseña', 'Ocurrió un error y no se ha podido enviar el correo.', 'error');
    });

    /*this.authenticationService.login( formValue.username , formValue.password )
      .pipe(first())
      .subscribe( data => {
          
          this.router.navigate(['/dashboard']);
          toastr.success(null, 'Mail enviado con la nueva contraseña', {positionClass: 'toast-top-center'});
        },
        error => {
          swal.fire('Login', 'No tienes permiso para entrar a la aplicación', 'error');
        }
      );*/
  }

  changePassword(formValue: any) {
    this.pasError = false;
    if (this.levelPass < 3) {
      swal.fire('Cambiar Contraseña', 'La contraseña debe tener 1 letra mayúscula, 1 número y una longitud mínima de 8', 'error');
    } else {
      if (formValue.password !== '' && formValue.confirm !== '' && this.levelPass === 3) {
        if (formValue.password !== formValue.confirm) {
          this.pasError = true;
        } else {
          this.pasError = false;
          this.api.changePassword(formValue, this.idUser).subscribe( data => {
            toastr.success(null, 'Contraseña cambiada correctamente', {positionClass: 'toast-top-center'});
            this.newUser = false;
            this.formLogin.reset();
            this.formForgot.reset();
            this.formNewPassword.reset();
          }, error => {
            swal.fire('Cambiar Contraseña', 'No se ha cambiado la contraseña, vuelva a intentarlo', 'error');
          });
      }
      }
    }
  }

  backToLogin() {
    this.showForgot = false;
  }

  onInputPass(value) {
    let cont = 0;
    if (value.length === 0) {
        this.levelPass = 0;
        return;
    }

    if (value.length > 7) {
        cont ++;
    }

    const matches = value.match(/\d+/g);
    if (matches != null) {
        cont ++;
    }

    if (/[A-Z]/.test(value)) {
        cont ++;
    }

    if (cont === 0) {
        cont++;
    }
    this.levelPass = cont;
}

}
